export default {
  sections: {
    settings: 'Settings',
  },
  status_switch: {
    label: 'Loyalty program',
    on: 'On',
    off: 'Off',
    description: 'Customers earn cashback on every order and can redeem it at checkout.',
    description_missing: 'Save the settings below to start your loyalty program.',
  },
  alerts: {
    off: "Your loyalty program is off. Customers don't earn cashback on new orders, can't redeem their points and don't see the program in your shop. Points they have already collected are kept and expire as usual.",
    expired: 'Your loyalty program has ended. Switch it on to restart it without an end date.',
  },
  form: {
    title: {
      label: 'Title',
    },
    percentage: {
      label: 'Cashback percentage',
      validation: {
        required: 'Cashback percentage is required',
        min: 'Cashback percentage minimum value is {{value}}%',
        max: 'Cashback percentage maximum value is {{value}}%',
      },
    },
    point_lifetime: {
      label: 'How many days you want to give your customers to use the points?',
      validation: {
        min: 'Minimum {{value}} days for points expiration',
      },
    },
    min_spending_limit: {
      label: 'Minimal spending limit for cashback',
      validation: {
        required: 'Minimal spending limit is required',
        gt_zero: 'Minimal spending limit must be greater than 0',
        lt_max_spending_limit: 'Minimal spending limit must be lower than maximal spending limit',
      },
    },
    max_spending_limit: {
      label: 'Maximal spending limit for cashback',
      validation: {
        required: 'Maximal spending limit is required',
        gt_min_spending_limit: 'Maximal spending limit must be higher than minimal spending limit',
      },
    },
    has_welcome_bonus: {
      label: 'Welcome bonus',
      description: 'Give your first time customers a sign in cashback bonus',
    },
    welcome_bonus: {
      label: 'Welcome bonus value',
    },
    has_end_date: {
      label: 'Duration',
      options: {
        false: 'Infinite',
        true: 'With specific end date',
      },
    },
    end_date: {
      label: 'End date',
    },
    has_mobile_app_signup_bonus: {
      label: 'Mobile App Sign-Up Bonus',
      description: 'Reward users who log in via the mobile app for the first time',
    },
    mobile_app_signup_bonus: {
      label: 'Bonus Amount',
    },
  },
  tags: {
    inactive: 'Not active',
    active: 'Active',
    expired: 'Expired',
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    changes_got_saved: 'Changes got saved',
    failed_to_save_changes: 'Failed to save changes',
    turned_on: 'Loyalty program turned on',
    turned_off: 'Loyalty program turned off',
  },
};
